import { render, staticRenderFns } from "./SocialLoginBox.vue?vue&type=template&id=5037111e&"
import script from "./SocialLoginBox.vue?vue&type=script&lang=ts&"
export * from "./SocialLoginBox.vue?vue&type=script&lang=ts&"
import style0 from "./SocialLoginBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports